/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
import { debounce } from "debounce";

/*------------------------------------*\
    EXHIBITIONS CAROUSEL
\*------------------------------------*/
class ExhibitionsCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        const navBtns = self.elem.querySelectorAll('[data-nav-btn]');

        // Function to init the carousel
        function initCarousel() {
            self.flkty = new Flickity(self.elem, {
                autoPlay: 3000,
                wrapAround: true,
                pageDots: false,
                arrowShape: 'M85.05,97.94a4.38,4.38,0,0,1-2.18-.57L0,50,82.87,2.65a4.36,4.36,0,0,1,6,1.59v0a4.36,4.36,0,0,1-1.62,6l0,0L17.56,50,87.27,89.79a4.36,4.36,0,0,1-2.22,8.15Z',
                on: {
                    ready: function () {
                        self.elem.classList.add('is-loaded');
                    }
                }
            });
        }

        // Init the carousel on page load
        initCarousel();

        // Function to destroy the carousel
        function destroyCarousel() {
            self.flkty.destroy();
            self.elem.classList.remove('is-loaded');
        }

        // On window resize, reload the carousel
        window.onresize = debounce(reloadCarousel, 200);

        // Function to reload the carousel
        function reloadCarousel() {
            // Destroy the carousel
            destroyCarousel();

            // Re-init the carousel
            initCarousel();
        }

        // Manage clicking of nav buttons
        navBtns.forEach(btn => {
            btn.addEventListener('click', evt => {
                let slide = parseInt(btn.getAttribute('data-nav-btn'));
                self.flkty.select(slide);
            });
        });
    }

}

export default ExhibitionsCarousel;
